module.exports = __webpack_public_path__ + "img/case-ct_compactsnipers_empty.1bca131.png";